/**
 * mwApp.shows module <br>
 * Work with TV shows: show/add/edit/remove
 *
 * @namespace mwApp/shows
 */

import AddShowCtrl from './addShow.controller'
import ExtractFromVideo from './extractFromVideo'
import ShowsCtrl from './shows.controller'
import showsConfig from './shows.config'
import AddSeasonCtrl from './addSeason.controller'
import AddEpisodeCtrl from './addEpisode.controller'
import CropCtrl from './crop.controller'
import { AlertCustomSvc, ConfirmCustomDlgCtrl } from './services/alert.service'
import SortEpisodesCtrl from './sortEpisodes.controller'

export default
angular.module('mwApp.shows', [])
  .config(showsConfig)
  .controller('ShowsCtrl', ShowsCtrl)
  .controller('AddShowCtrl', AddShowCtrl)
  .controller('AddSeasonCtrl', AddSeasonCtrl)
  .controller('SortEpisodesCtrl', SortEpisodesCtrl)
  .controller('AddEpisodeCtrl', AddEpisodeCtrl)
  .controller('CropCtrl', CropCtrl)
  .controller('ExtractFromVideo', ExtractFromVideo)
  .controller('ConfirmCustomDlgCtrl', ConfirmCustomDlgCtrl)
  .service('alertCustomSvc', AlertCustomSvc)
